import { render, staticRenderFns } from "./DataTableDocuments.vue?vue&type=template&id=5fe251ca"
import script from "./DataTableDocuments.vue?vue&type=script&lang=js"
export * from "./DataTableDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports